<template>
  <v-container>
    <v-dialog
      v-model="dialog"
      :class="{ 'dialog-top': $vuetify.breakpoint.mobile }"
      width="400"
      :fullscreen="fullScreenDialog"
    >
      <v-card class="px-5 pb-5">
        <form>
          <v-row no-gutters>
            <v-col cols="10">
              <v-card-title>
                {{ $t("label.login") }}
              </v-card-title>
            </v-col>
            <v-col cols="2" class="my-auto">
              <v-btn
                color="primary"
                small
                icon
                @click="dialog = false"
                class="float-right mx-6"
                ><v-icon>{{ mdiCloseThick }}</v-icon></v-btn
              >
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-text>
            <v-row no-gutters>
              <v-text-field
                :prepend-inner-icon="mdiAccount"
                :label="$t('label.member_no')"
                :rules="rules"
                required
                v-model="memberNo"
                outlined
              ></v-text-field>
            </v-row>
            <v-row no-gutters>
              <v-text-field
                :prepend-inner-icon="mdiLock"
                :label="$t('label.password')"
                :rules="rules"
                required
                v-model="password"
                outlined
                :type="show1 ? 'text' : 'password'"
                :append-icon="show1 ? mdiEye : mdiEyeOff"
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-row>

            <v-row no-gutters>
              <v-btn color="primary" dark large tile @click="login"
                ><span style="font-size: x-large; text-transform: none">{{
                  $t("label.login")
                }}</span></v-btn
              >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="toForgetPassword()">{{
                $t("label.forget_password")
              }}</v-btn>
            </v-row>
          </v-card-text>
        </form>
      </v-card>
    </v-dialog>
    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
    <loading-dialog v-model="showLoading" />
  </v-container>
</template>

<script>
import { mdiCloseThick, mdiAccount, mdiLock, mdiEye, mdiEyeOff } from "@mdi/js";
import { SystemLogin } from "@/api/publicServices";
import i18n from "../lang/lang";
import LoadingDialog from "./LoadingDialog.vue";
export default {
  name: "Login",
  // metaInfo: {
  //   title: "登入",
  //   titleTemplate: "%s | 青蛙集運",
  // },
  mounted() {
    this.initMemberID();
  },
  props: {
    value: Boolean,
  },
  components: {
    LoadingDialog: LoadingDialog,
  },
  computed: {
    fullScreenDialog() {
      return localStorage.getItem("flutter") == "true";
    },
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data: () => ({
    rules: [
      (value) => !!value || i18n.t("label.required"),
      (value) => (value && value.length >= 3) || "Min 3 characters",
    ],
    memberNo: "",
    password: "",
    pol: {},
    remember: true,
    show1: false,

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    showLoading: false,

    // svg icons
    mdiCloseThick,
    mdiAccount,
    mdiLock,
    mdiEye,
    mdiEyeOff,
  }),
  methods: {
    initMemberID() {
      let siteMemberNo = localStorage.getItem("site_member_no");
      if (siteMemberNo != null) {
        this.memberNo = siteMemberNo;
      }
    },
    async login(e) {
      e.preventDefault();
      if (this.password.length > 0) {
        try {
          let data = { MemberNo: this.memberNo, Password: this.password };
          data["DeviceID"] = localStorage.getItem("FLUTTER_DEVICE_ID");
          data["DeviceToken"] = localStorage.getItem("FLUTTER_DEVICE_TOKEN");
          console.log(data);
          this.showLoading = true;
          const response = await SystemLogin(data);

          if (response.data.isSuccess) {
            localStorage.setItem("member_no", this.memberNo);
            localStorage.setItem("access_token", response.data.Msg);

            if (this.remember) {
              localStorage.setItem("site_member_no", this.memberNo);
            }
            this.$router.push("management");
          } else {
            //alert(response.data.Msg);
            this.snackBarMsg.text = response.data.Msg;
            this.snackBarMsg.show = true;
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.showLoading = false;
        }
      }
    },
    toForgetPassword() {
      console.log("toForgetPassword");
      try {
        //this.$router.push("forget_password");
        this.$router.push({ name: "forget_password" }).catch(() => {});
        this.dialog = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.smaller {
  font-size: smaller;
}

@media (max-width: 960px) {
  .v-dialog__content {
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
